export default __webpack_public_path__ + "static/media/ball-effect.198b7608.mp3";